import { cloneDeep } from 'lodash-es'
import { PermissionRole } from '../auth/type'
import type { PermissionMap, PermissionMapKey } from './types'
import { Roles, modulesPermission } from './types'

const store = defineStore('permission', () => {
  const permissionMap = computed<PermissionMap>(() => cloneDeep(modulesPermission))
  const role = ref<Roles>(Roles.Guest)

  /**
   * 判断当前用户角色是否有权限访问某个模块
   * @param module 被访问的模块
   * @param userRole 用户角色  Roles.Admin | Roles.HeadChannelManager | Roles.ChannelManager | Roles.Members
   * @returns 是否有权限访问
   */
  function canAccess(module: PermissionMapKey, userRole: Roles = role.value): boolean {
    // if (userRole & permissionMap.value[module]) {
    //   console.log('用户有权限访问该模块')
    // }
    // else {
    //   console.log('用户没有权限访问该模块')
    // }
    let curRole = userRole || role.value
    // 如果是超级管理员则有权限查看所有模块
    if (curRole === Roles.Admin)
      curRole = Roles.HeadChannelManager
    return Boolean(curRole & permissionMap.value[module])
  }

  /**
   * 更新当前用户角色
   * @param permissionView 视图权限
   * @param isAdmin 是否是超级管理员
   */
  function setRole(permissionView: PermissionRole, isAdmin: boolean) {
    if (isAdmin) {
      role.value = Roles.Admin
      return
    }

    switch (permissionView) {
      case PermissionRole.HeadChannelManager:
        role.value = Roles.HeadChannelManager
        break
      case PermissionRole.ChannelManager:
        role.value = Roles.ChannelManager
        break
      case PermissionRole.Members:
        role.value = Roles.Members
        break
      default:
        role.value = Roles.Guest
        break
    }
  }

  return {
    permissionMap,
    canAccess,
    setRole,
  }
})

export default store
